module.exports = __webpack_public_path__ + "img/62c1a012179f4fed8aef402ae2e4d0de.66e692cf.png";